import React from 'react';
import { PharmacyNameWrapper } from '../../../healtheraComponents';
import useLocationQuery from '../../../hooks/useQuery';
import { LIVE_DASHBOARD } from '../constants';

const ReportsPharmacyName = ({ pharmacyName, pharmacyId }) => {
  const { changeLocationQuery } = useLocationQuery();

  const pharmacyRedirectHandler = () => {
    changeLocationQuery({
      tab: LIVE_DASHBOARD,
      pharmacy_id: pharmacyId,
    });
  };
  return (
    <PharmacyNameWrapper onClick={pharmacyRedirectHandler}>
      {pharmacyName}
    </PharmacyNameWrapper>
  );
};

export default ReportsPharmacyName;
